enum QuickApiDocumentTypeEnum {
    CONSENT = 1,
    RGPD = 2,
    DD = 3,
    REVOCATION = 4,
    FILE = 6,
  }

  export default QuickApiDocumentTypeEnum;